





































































import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';
import { DocuSignAdditionalDocumentFileModel, DocuSignAdditionalDocumentFileConfigurationModel } from '@/types';
import { RouteRegEx } from '@/types/enums';
import { DocuSignConfigurationService } from '@/services/docuSign/DocuSignConfigurationService';
import { ComponentHelper, MTablehelper, RouteHelpers, confirmationHelper } from '@/mixins';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import Vue from 'vue';
export default Vue.extend({
  name: 'DocusignAdditionalDocumentManagement',
  mixins: [ComponentHelper, MTablehelper, RouteHelpers, confirmationHelper],
  data() {
    return {
      pageIsLoading: true,
      isLoading: false,
      fields: [
        {
          fileName: {
            label: 'Filename',
            sortable: true
          }
        },
        {
          description: {
            label: 'Description',
            sortable: true
          }
        },
        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ],
      items: [] as DocuSignAdditionalDocumentFileModel[],
      fileUploadSizeLimitMb: 1,
      hasError: false,
      errorMessage: '',
      tableStateKey: MTablehelper.Constants.TableStoreKeys.DocuSignAdditionalDocuments,
      rowSubmitting: -1
    };
  },
  methods: {
    async getAdditionalDocuments(this: any) {
      try {
        this.isLoading = true;
        // tslint:disable-next-line:max-line-length
        const additionalDocumentFileConfiguration = await DocuSignConfigurationService.getAdditionalDocumentFileConfigurationAsync();
        this.items = additionalDocumentFileConfiguration.additionalDocumentFiles;
        this.fileUploadSizeLimitMb = additionalDocumentFileConfiguration.fileUploadSizeLimitMb;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
    navigateToId(this: any, routeName: any, data: any = null, paramName: string = 'id') {
      if (data) {
        const value = paramName === 'id' ? data : data.id;
        this.onTableStateFieldUpdated('selectedPk', value, this.tableStateKey);
      }
      this.navigateToRoute(routeName, data, paramName);
    },
    async deleteAdditionalDocument(this: any, id: number) {
      try {
        const result = await this.hasDeleteConfirmedAsync(
          this.$bvModal,
          'Are you sure you want to delete this note?'
        );
        if (result) {
          this.isLoading = true;
          this.rowSubmitting = id;
          await DocuSignConfigurationService.deleteAdditionalDocumentFileAsync(id);
          SnotifyConfiguration.showSuccess('Additional document deleted successfully.');
          await this.getAdditionalDocuments();
        }
      } catch (error) {
        this.$log('failed to delete additional document', error);
      } finally {
        this.isLoading = false;
        this.rowSubmitting = -1;
      }
    },
    resetViewState(this: any) {
      const canKeepState = this.canKeepState(RouteRegEx.DocuSignAdditionalDocuments);
      if (!canKeepState) {
        this.resetMTableState(this.tableStateKey);
      }
    },
    async initialise(this: any) {
      try {
        this.pageIsLoading = true;
        this.resetViewState();
        await this.getAdditionalDocuments();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.pageIsLoading = false;
      }
    }
  },
  components: {
    MStoreTable,
    LoadingSpinner,
    MStoreSpinnerButton
  },
  mounted() {
    this.initialise();
  }
});
